import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderVisibilityService {
  private headerVisibleSubject = new BehaviorSubject<boolean>(true);
  public headerVisible$: Observable<boolean> = this.headerVisibleSubject.asObservable();

  hideHeader(): void {
    this.headerVisibleSubject.next(false);
  }

  showHeader(): void {
    this.headerVisibleSubject.next(true);
  }

  isHeaderVisible(): boolean {
    return this.headerVisibleSubject.value;
  }
}
